export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer'
  },
  {
    name: 'Pontos',
    url: '/points',
    icon: 'icon-layers',
    children: [{
      name: 'Pontos Inpar',
      url: '/points',
      icon: 'icon-speedometer'
    }, {
      name: 'Pontos Olá',
      url: '/points_ola',
      icon: 'icon-speedometer'
    }, {
      name: 'Pontos Mês',
      url: '/points_month',
      icon: 'icon-speedometer'
    }, {
      name: 'Pontos Ano',
      url: '/points_year',
      icon: 'icon-speedometer'
    }, {
      name: 'Pontos Gastos',
      url: '/points_spent',
      icon: 'icon-speedometer'
    }, {
      name: 'Saldos',
      url: '/points_balance',
      icon: 'icon-speedometer'
    }]
  },
  {
    name: 'Administradores',
    url: '/admins',
    icon: 'icon-user'
  },
  {
    name: 'Cálculos',
    url: '/calcs',
    icon: 'icon-calculator'
  },
  {
    name: 'Definições',
    url: '/settings/edit',
    icon: 'icon-calculator'
  },
  {
    name: 'Formulários Site',
    url: '/siteregistrations',
    icon: 'icon-speech'
  },
  {
    name: 'Campanhas',
    url: '/campaigns',
    icon: 'icon-layers',
    children: [{
      name: 'Bestof',
      url: '/campaigns/bestof',
      icon: 'icon-puzzle',
      children: [{
        name: 'Campanhas',
        url: '/campaigns/bestof/campaigns',
        icon: 'icon-list'
      }, {
        name: 'Objectivos Zonas',
        url: '/campaigns/bestof/objectives',
        icon: 'icon-puzzle'
      }, {
        name: 'Objectivos DSR',
        url: '/campaigns/bestof/dsr-objectives',
        icon: 'icon-puzzle'
      }, {
        name: 'Objectivos Leader',
        url: '/campaigns/bestof/leader-objectives',
        icon: 'icon-puzzle'
      }, {
        name: 'Resultados Zona',
        url: '/campaigns/bestof/results',
        icon: 'icon-puzzle'
      }, {
        name: 'Resultados DSR',
        url: '/campaigns/bestof/dsr-results',
        icon: 'icon-puzzle'
      }, {
        name: 'Resultados Leader',
        url: '/campaigns/bestof/leader-results',
        icon: 'icon-puzzle'
      }]
    }, {
      name: 'Inpar',
      url: '/campaigns/inpar',
      icon: 'icon-puzzle',
      children: [{
        name: 'Critérios',
        url: '/campaigns/inpar/criteria',
        icon: 'icon-puzzle'
      }, {
        name: 'Bónus',
        url: '/campaigns/inpar/bonus',
        icon: 'icon-puzzle'
      }, {
        name: 'Operadores Excluidos',
        url: '/campaigns/inpar/excluded-operators',
        icon: 'icon-puzzle'
      }, {
        name: 'Resultados DSR',
        url: '/campaigns/inpar/results',
        icon: 'icon-puzzle'
      }, {
        name: 'Resultados Leaders',
        url: '/campaigns/inpar/leader-results',
        icon: 'icon-puzzle'
      }]
    }, {
      name: 'Pontos Extra',
      url: '/campaigns/extra',
      icon: 'icon-puzzle'
    }, {
      name: 'Pontos Olá',
      url: '/campaigns/ola',
      icon: 'icon-puzzle'
    }]
  },
  {
    name: 'Scorecard',
    url: '/scorecard',
    icon: 'icon-layers',
    children: [{
      name: 'NIF Excluídos',
      url: '/scorecard/excluded',
      icon: 'icon-puzzle'
    }, {
      name: 'Objectivos',
      url: '/scorecard/objectives',
      icon: 'icon-puzzle'
    }, {
      name: 'Resultados',
      url: '/scorecard/results',
      icon: 'icon-puzzle'
    }]
  },
  {
    name: 'SC Independentes',
    url: '/scorecard-independents',
    icon: 'icon-layers',
    children: [{
      name: 'Operadores',
      url: '/scorecard-independents/operators',
      icon: 'icon-puzzle'
    }, {
      name: 'Objectivos',
      url: '/scorecard-independents/objectives',
      icon: 'icon-puzzle'
    }, {
      name: 'Resultados',
      url: '/scorecard-independents/results',
      icon: 'icon-puzzle'
    }]
  },
  {
    name: 'Vendas',
    url: '/sales',
    icon: 'icon-layers',
    children: [{
      name: 'Sellout',
      url: '/sales/sellout',
      icon: 'icon-puzzle'
    }, {
      name: 'Sellin',
      url: '/sales/sellin',
      icon: 'icon-puzzle'
    }, {
      name: 'Prob. Distribuidores',
      url: '/sales/distsales',
      icon: 'icon-puzzle'
    }, {
      name: 'Refazer CCSS',
      url: '/sales/remake/ccss',
      icon: 'icon-puzzle'
    }, {
      name: 'Refazer Dist',
      url: '/sales/remake/dists',
      icon: 'icon-puzzle'
    }, {
      name: 'Refazer Sellin',
      url: '/sales/remake/sellin',
      icon: 'icon-puzzle'
    }]
  },
  {
    name: 'Produtos',
    url: '/products',
    icon: 'icon-layers',
    children: [{
      name: 'Produtos',
      url: '/products/products',
      icon: 'icon-puzzle'
    }, {
      name: 'Produtos Agregados',
      url: '/products/prodaggregs',
      icon: 'icon-puzzle'
    }, {
      name: 'Marcas',
      url: '/products/brands',
      icon: 'icon-puzzle'
    }, {
      name: 'Divisions',
      url: '/products/divisions',
      icon: 'icon-puzzle'
    }, {
      name: 'Categorias',
      url: '/products/categories',
      icon: 'icon-puzzle'
    }, {
      name: 'Shopping Groups',
      url: '/products/shoppinggroups',
      icon: 'icon-puzzle'
    }, {
      name: 'Subsectors',
      url: '/products/subsectors',
      icon: 'icon-puzzle'
    }, {
      name: 'Top 10',
      url: '/products/top10',
      icon: 'icon-puzzle'
    }, {
      name: 'Variedades',
      url: '/products/varieties',
      icon: 'icon-puzzle'
    }]
  },
  {
    name: 'Distribuidores',
    url: '/dealers',
    icon: 'icon-layers',
    children: [{
      name: 'Distribuidores',
      url: '/dealers/dealers',
      icon: 'icon-puzzle'
    }, {
      name: 'Últimas Vendas',
      url: '/dealers/lastsales/index',
      icon: 'icon-puzzle'
    }, {
      name: 'DSR',
      url: '/dealers/dsr/index',
      icon: 'icon-user'
    }, {
      name: 'Códigos DSR',
      url: '/dealers/dsr_codes/index',
      icon: 'icon-puzzle'
    },{
      name: 'Equipas',
      url: '/dealers/teams/index',
      icon: 'icon-user'
    }, {
      name: 'Equipas Managers',
      url: '/dealers/teams/managers',
      icon: 'icon-user'
    }, {
      name: 'Operadores',
      url: '/dealers/operators/index',
      icon: 'icon-user'
    }, {
      name: 'Grupos Operadores',
      url: '/dealers/operator_groups/index',
      icon: 'icon-user'
    }, {
      name: 'Produtos Dist.',
      url: '/dealers/products/index',
      icon: 'icon-user'
    }]
  }, {
    name: 'Stars',
    url: '/stars',
    icon: 'icon-star',
    children: [{
      name: 'WS Relations',
      url: '/stars/ws_relations',
      icon: 'icon-puzzle'
    }, {
      name: 'WS Objectivos',
      url: '/stars/ws_objectives',
      icon: 'icon-puzzle'
    }, {
      name: 'WS Obj Trim',
      url: '/stars/ws_objectives_quarter',
      icon: 'icon-puzzle'
    }, {
      name: 'Sellin Objectives',
      url: '/stars/sellin_objectives',
      icon: 'icon-puzzle'
    }, {
      name: 'Shipto Objectives',
      url: '/stars/shipto_objectives',
      icon: 'icon-puzzle'
    }]
  }
  ]
}
